module.exports = __webpack_public_path__ + "img/armaBoca4.3670ccf7.jpg";